<template>
  <div class="tpass-warp tpReceiptRecord bg-white">
    <t-pass-header
      :title="'歸戶'"
      :routerUrl="'taipeiPassAppReceiptRecord'"
      :isRecord="true"
      :receiptToken="receiptToken"
    ></t-pass-header>
    <div v-if="isConsole" class="console">
      <div>Path === {{ this.$route.fullPath }}</div>
      <div>$route.params === {{ $route.params }}</div>
      <div>$route.query === {{ $route.query }}</div>
    </div>

    <loading :show="apiLoading" :isTpass="true"></loading>
    <div class="tpass-container">
      <validation-observer ref="formObs" slim v-slot="{ handleSubmit }">
        <b-form ref="manualForm" @submit.prevent="handleSubmit()" class="formInquire tpass-form">
          <div class="mb-3">
            <b-button variant="primary-2" block class="btn-fat tp-btn" @click="scanning()">
              <img class="vertical-text-top" src="@/assets/images/scanning.png" alt="valid" />
              掃描收據條碼
            </b-button>
          </div>

          <divider :class="'mt-1half-rem'" tag="span" title="或" position="center" />
          <validation-provider
            rules="required|alpha_num"
            v-slot="{ validated, errors, failed }"
            slim
            name="收據號碼"
          >
            <b-form-group
              label="收據號碼"
              label-for="inputReceiptNumber"
              :invalid-feedback="errors[0]"
            >
              <b-input
                id="inputReceiptNumber"
                title="收據號碼"
                placeholder="請輸入收據號碼，如：ZZ1100000001"
                v-model="manualFormData.rpPublicNo"
                :state="validated ? !failed : null"
                autocomplete="off"
                spellcheck="false"
                refs="rpPublicNoRefs"
              />
              <div
                v-if="manualFormData.rpPublicNo"
                class="input-clear"
                @click="manualFormData.rpPublicNo = ''"
              ></div>
            </b-form-group>
          </validation-provider>
          <validation-provider
            rules="required|numeric|minLength:4"
            v-slot="{ validated, errors, failed }"
            slim
            name="檢核碼"
          >
            <b-form-group label="檢核碼" label-for="inputReceiptCode" :invalid-feedback="errors[0]">
              <b-input
                id="inputReceiptCode"
                title="檢核碼"
                type="number"
                pattern="[0-9]*"
                placeholder="請輸入檢核碼，如：9999"
                v-model.trim="manualFormData.rpPublicRandomCode"
                :state="validated ? !failed : null"
                autocomplete="off"
                spellcheck="false"
              />
              <div
                v-if="manualFormData.rpPublicRandomCode"
                class="input-clear"
                @click="manualFormData.rpPublicRandomCode = ''"
              ></div>
            </b-form-group>
          </validation-provider>
          <div class="mb-3">
            <b-button
              :variant="!isValid ? 'secondary-2' : 'primary-2'"
              :disabled="!isValid"
              block
              class="btn-fat tp-btn"
              @click="goTpDetail()"
              >查詢收據</b-button
            >
          </div>
        </b-form>
      </validation-observer>
      <t-pass-directions
        ref="tPassDirections"
        :content="content"
        :bgColor="'bg-white'"
      ></t-pass-directions>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import CommonApiMixin from '@/mixins/commonApi';
import ApiMixin from '@/mixins/api';

export default {
  name: 'TpassReceiptReturnHome',

  mixins: [CommonApiMixin, ApiMixin],

  data() {
    return {
      content: [
        {
          value: '1',
          text:
            '本電子收據系統由機關依個別法規規定應載明事項辦理，對收據劇內容有疑義，請逕洽收據開立機關承辦人。',
        },
        {
          value: '2',
          text: '收據如經作廢，最新狀態請依平台顯示為主。',
        },
        {
          value: '3',
          text: '每張收據僅能歸戶一次，取得收據者可歸戶至台北通帳戶(未限制須為繳款人本人)。',
        },
        {
          value: '3',
          text: '僅限開立日期一年內之收據資料可供查詢及歸戶。',
        },
      ],
      isValid: false,
      reqData: {},
      apiLoading: false,
      receiptToken: null,
      manualFormData: {
        rpPublicNo: '',
        rpPublicRandomCode: '',
      },

      isConsole: false,
    };
  },

  created() {
    if (this.$route.params.receiptToken) {
      this.receiptToken = this.$route.params.receiptToken ?? '';
    } else {
      this.receiptToken = this.$route.query.receiptToken ?? '';
    }

    this.token = this.$store.getters['tPassToken/getTPassToke'];
    if (this.$route.query.token) {
      this.setTPassToken(this.$route.query.token);
    }
    console.log('---home------this.$route.params', this.$route.params);
    console.log('---home------this.receiptToken', this.receiptToken);
    this.reqData.rpPublicNo = this.manualFormData.rpPublicNo;
    this.reqData.rpPublicRandomCode = this.manualFormData.rpPublicRandomCode;
  },

  mounted() {
    this.updateFormValidity();
  },

  watch: {
    manualFormData: {
      deep: true,
      handler(val) {
        console.log(' val ', val);
        this.updateFormValidity();
      },
    },
  },

  methods: {
    ...mapMutations('tPassToken', ['setTPassToken']),
    viewClose() {
      window.location = `viewclose://`;
    },
    async updateFormValidity() {
      this.isValid =
        (await this.$refs.formObs.validate({
          silent: true,
        })) && !!(this.manualFormData.rpPublicNo && this.manualFormData.rpPublicRandomCode);
    },
    scanning() {
      const urlEncode = `${process.env.VUE_APP_URL}/TPGovEReceipt/Taipeipass/receiptReturnHome?receiptToken=${this.receiptToken}&token=${this.token}`;
      const toolbarObj = JSON.stringify({
        enable: false,
        closeIconColor: '#FFFFFF',
        statusBarColor: '#2EB6C7',
      });

      // Base64 編碼
      // const toolbarEncodedData = btoa(encodeURI(JSON.stringify(toolbarEncode)));
      // console.log('toolbarEncodedData-', toolbarEncodedData);
      // const toolbarDecodedData = decodeURI(atob(toolbarEncodedData));
      // console.log('toolbarDecodedData解碼-', JSON.parse(toolbarDecodedData));

      // encodeURI 編碼
      const encoded = encodeURI(urlEncode);
      // console.log('encodeURI 編碼-', encoded);
      // console.log('encodeURI 解碼-', decodeURI(encoded));

      // native://doaction?target=**appScan**&**redirect**={redirect url}&toolbar={url safe base64 String}
      // window.location = `native://doaction?target=appScan&source=電子收據的 WebView&redirect=${encoded}&toolbar=eyJlbmFibGUiOmZhbHNlLCJjbG9zZUljb25Db2xvciI6IiNGRkZGRkYiLCJzdGF0dXNCYXJDb2xvciI6IiMyRUI2QzcifQ`;
      const nativeUrl = `native://doaction?target=appScan&source=電子收據的 WebView&redirect=${encoded}&toolbar=${toolbarObj}`;
      console.log('@@@@@', nativeUrl);
      window.location = nativeUrl;
    },
    goTpDetail() {
      this.$router.push({
        name: 'taipeiPassAppReceiptDetail',
        params: {
          rpPublicNo: this.manualFormData.rpPublicNo,
          rpPublicRandomCode: this.manualFormData.rpPublicRandomCode,
          receiptToken: this.receiptToken,
        },
      });
    },

    success(type, result) {
      console.log('result', result);
      switch (type) {
        default:
          break;
      }
    },
    fail() {
      this.apiLoading = false;
    },
  },
};
</script>
